import React from "react";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import NotesOutlinedIcon from "@mui/icons-material/NotesOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { hasDetailValue } from "../../utils/detailUtils";

const iconMap = {
  article: ArticleOutlinedIcon,
  notes: NotesOutlinedIcon,
  link: LinkOutlinedIcon,
  info: InfoOutlinedIcon,
};

function ContentSection({ title, value, html = false, myanmar = false, icon = "article" }) {
  if (!hasDetailValue(value)) return null;

  const Icon = iconMap[icon] || ArticleOutlinedIcon;
  const valueClassName = [
    "detail-section-body",
    myanmar ? "detail-section-body--myanmar" : "",
    html ? "detail-section-body--rich" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className="detail-content-section">
      <div className="detail-content-section-head">
        <span className="detail-section-icon">
          <Icon fontSize="small" />
        </span>
        <h3 className="detail-section-title">{title}</h3>
      </div>
      {html ? (
        <div
          className={valueClassName}
          lang={myanmar ? "my" : undefined}
          dangerouslySetInnerHTML={{ __html: String(value).trim() }}
        />
      ) : (
        <div className={valueClassName} lang={myanmar ? "my" : undefined}>
          {value}
        </div>
      )}
    </section>
  );
}

export default function DetailContentPanel({ imageUrl, sections = [] }) {
  const visibleSections = sections.filter((section) => hasDetailValue(section.value));

  if (!imageUrl && visibleSections.length === 0) {
    return null;
  }

  return (
    <div className="detail-main-card">
      {imageUrl && <img className="detail-image" src={imageUrl} alt="" />}
      {visibleSections.length > 0 && (
        <div className="detail-content-sections">
          {visibleSections.map((section) => (
            <ContentSection key={section.title} {...section} />
          ))}
        </div>
      )}
    </div>
  );
}
